import React, { useState, useRef } from 'react';
import { Send, Loader2 } from 'lucide-react';
import './MessageInput.css';

const MessageInput = ({ onSendMessage, isLoading, isConnected }) => {
  const [message, setMessage] = useState('');
  const textareaRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim() && !isLoading && isConnected) {
      onSendMessage(message);
      setMessage('');
      if (textareaRef.current) {
        textareaRef.current.style.height = 'auto';
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const handleTextareaChange = (e) => {
    setMessage(e.target.value);
    
    // Auto-resize textarea
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = Math.min(textarea.scrollHeight, 120) + 'px';
    }
  };

  const placeholder = !isConnected 
    ? 'Connecting to server...' 
    : 'Type your message here... (Press Enter to send, Shift+Enter for new line)';

  return (
    <div className="message-input-container">
      <form onSubmit={handleSubmit} className="message-input-form">
        <div className="input-wrapper">
          <textarea
            ref={textareaRef}
            value={message}
            onChange={handleTextareaChange}
            onKeyPress={handleKeyPress}
            placeholder={placeholder}
            disabled={isLoading || !isConnected}
            className="message-textarea"
            rows={1}
          />
          
          <button
            type="submit"
            disabled={!message.trim() || isLoading || !isConnected}
            className="send-button"
            title={isLoading ? 'Sending...' : 'Send message'}
          >
            {isLoading ? (
              <Loader2 size={20} className="spinning" />
            ) : (
              <Send size={20} />
            )}
          </button>
        </div>
      </form>
      
      {!isConnected && (
        <div className="connection-warning">
          ⚠️ Not connected to server. Please check your connection.
        </div>
      )}
    </div>
  );
};

export default MessageInput;